/*
  attribution — end-to-end ?src=<article-slug> propagation, without a new
  analytics service. An article's primary CTA appends ?src=<slug> to an
  internal destination (lib/content.ts::withSrc); this module is the other
  half: any page that can be a destination (Signal, Vault, Tools, Audit,
  About, Data, the Log index) reads that same query param back and
  (a) includes it as a distinct field in the EmailCapture submission, and
  (b) tags outbound storefront links (Gumroad/Stripe) with a matching UTM
  pair — so the originating article survives to both conversion events.
*/
import { useSearchParams } from "wouter";

export function useUrlSrc(): string | undefined {
  const [params] = useSearchParams();
  return params.get("src") ?? undefined;
}

/* Tags an outbound (or internal) URL with UTM params derived from the
   visit's ?src, if any. No-op when there's no src to propagate. */
export function withUtm(href: string, src: string | undefined): string {
  if (!src) return href;
  const sep = href.includes("?") ? "&" : "?";
  return `${href}${sep}utm_source=bearth&utm_medium=referral&utm_campaign=${encodeURIComponent(src)}`;
}
